import { AuthenticateWithRedirectCallback } from "@clerk/clerk-react";
import { LoadingSpinner } from "./LoadingSpinner";

export function SSOCallback() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 dark:bg-slate-900">
      <div className="text-center space-y-4">
        <LoadingSpinner />
        <p className="text-slate-600 dark:text-slate-400">
          Completing authentication...
        </p>
        {/* Handle the OAuth redirect callback as per Clerk documentation */}
        <AuthenticateWithRedirectCallback />
      </div>
    </div>
  );
}
